/* eslint-disable max-len */
import React from 'react';

import { Box } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import {
  Stack,
  BodyText,
  HeaderText,
  Absolute,
} from '../../../ui';
import {
  BasicCircleStarIcon,
} from '../../../ui/Icons';
import PortalOverlay, {
  PortalOverlayModal,
  PortalOverlayHeader,
} from '../../../ui/PortalOverlay';
import IncentivesCloseIcon from '../IncentivesCloseIcon';

export type AboutIncentivesModalProps = {
  onDismiss: () => void;
  renderCTA: () => React.ReactNode | React.ReactNode[];
};

export default function AboutIncentivesModal({
  onDismiss,
  renderCTA,
}: AboutIncentivesModalProps) {
  return (
    <PortalOverlay name="about-incentives-modal">
      <PortalOverlayModal position="fullScreen" color={colors.redLite}>
        <PortalOverlayHeader
          style={{
            borderBottomColor: colors.blackInBlack,
          }}
          renderTitle={() => (
            <Box paddingTop={12}>
              <HeaderText level={2}>
                Details
              </HeaderText>
            </Box>
          )}
          renderRightAction={() => (
            <Box padding={8}>
              <IncentivesCloseIcon
                onDismiss={onDismiss}
                size={16}
                testID="about-incentives-modal_close-icon"
              />
            </Box>
          )}
        />
        <Stack paddingLeft={32} paddingTop={64} paddingBottom={8}>
          <BasicCircleStarIcon
            color={colors.punch}
            width={64}
            height={64}
          />
        </Stack>
        <Stack paddingRight={20} paddingLeft={40}>
          <Box paddingTop={12}>
            <HeaderText level={1} lineHeight={40} fontSize={32}>
              Get 15% off{'\n'}appointments
            </HeaderText>
          </Box>
          <Stack
            space={20}
            paddingTop={12}
            paddingLeft={0}
          >
            <Box>
              <BodyText color={colors.metal}>
                Receive 15% off (max discount $50) when you discover and book with an eligible new pro on StyleSeat.
              </BodyText>
            </Box>
            <Box>
              <BodyText color={colors.metal}>
                Discount applied at checkout.
              </BodyText>
            </Box>
            <Box>
              <BodyText color={colors.metal}>
                Must complete payment through StyleSeat.
              </BodyText>
            </Box>
            <Box>
              <BodyText color={colors.metal}>
                Cannot be combined with other offers.
              </BodyText>
            </Box>
          </Stack>
        </Stack>
        <Absolute bottom={20} left={0} right={0}>
          {renderCTA()}
        </Absolute>
      </PortalOverlayModal>
    </PortalOverlay>
  );
}
